import { TextField } from "@mui/material";
import styled, { keyframes } from "styled-components";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export const Title = styled.p`
  text-transform: uppercase;
  font-family: "Roboto";
  font-weight: 900;
  color: rgba(55, 73, 87, 0.7);
  font-size: 1.5rem;

  z-index: 2;

  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  -ms-flex-align: center;
  -webkit-align-items: center;
`;

export const ContentInput = styled(TextField)`
    margin-top: 0.5rem !important;
`;

export const CopyBox = styled.div`
  display: flex;
  width: 40%;
  max-width: 400px;
  gap: 0.5rem;

  flex-direction: row;
  justify-content: space-between;

  align-items: center;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  cursor: default;
  user-select: text;
`;

export const CopyIcon = styled.div`
  margin-left: 0.5rem;
  cursor: pointer;
  color: #666;

  &:hover {
    color: #2e933c;
  }
`;

const fadeInOut = keyframes`
  0% { opacity: 0; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
`;

export const AnimatedIcon = styled(CheckCircleOutlineIcon)`
  color: rgba(46, 199, 0, 0.7);
  align-self: center;

  animation: ${fadeInOut} 2s ease-in-out 1;
`;

export const ConfirmBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: rgba(46, 199, 0, 0.7);
  font-size: 1.5rem;
  font-weight: 500;
`;

export const CopyText = styled.p`
  font-family: "Roboto";
  font-size: 1rem;
  font-weight: 500;
  color: rgba(55, 73, 87, 0.7);
`;